import { render } from "./PieChartEdit.vue?vue&type=template&id=5fde06bc&scoped=true"
import script from "./PieChartEdit.vue?vue&type=script&lang=js"
export * from "./PieChartEdit.vue?vue&type=script&lang=js"

import "./PieChartEdit.vue?vue&type=style&index=0&id=5fde06bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fde06bc"],['__file',"src/components/mediaproperty/PieChartEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5fde06bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5fde06bc', __exports__)) {
    api.reload('5fde06bc', __exports__)
  }
  
  module.hot.accept("./PieChartEdit.vue?vue&type=template&id=5fde06bc&scoped=true", () => {
    api.rerender('5fde06bc', render)
  })

}


export default __exports__